import * as React from 'react';

import './CardContainer.scss';

interface ICardContainerProps {
    height?: string;
    id?: string;
    className?: string;
}

const CardContainer: React.StatelessComponent<ICardContainerProps> = (props) => {
    let modElements: JSX.Element[] = [];

    const cardStyle = {
        height: props.height || 'auto',
    };

    let width = 100;

    if (Array.isArray(props.children)) {
        width = 100 / (props.children as Array<JSX.Element>).length;
        modElements = (props.children as Array<JSX.Element>).map((element: JSX.Element, index: number) =>
            React.cloneElement(element, { key: `card-${index}`, style: { width: `${width}%` } })
        );
    } else {
        modElements.push(React.cloneElement(props.children as JSX.Element, { key: 'card-1', style: { width: `${width}%` } }));
    }

    return (
        <>
            <div className={props.className || 'lh-card-container'} id={props.id} style={cardStyle}>
                {modElements}
            </div>
        </>
    );
};

CardContainer.displayName = 'CardContainer';
export default CardContainer;



// WEBPACK FOOTER //
// ./src/components/common/CardContainer.tsx